import { render, staticRenderFns } from "./CalendarSummaryView.vue?vue&type=template&id=6f9f7509&scoped=true&"
import script from "./CalendarSummaryView.vue?vue&type=script&lang=js&"
export * from "./CalendarSummaryView.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSummaryView.vue?vue&type=style&index=0&id=6f9f7509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f7509",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VFlex,VIcon,VLayout})
